import React from 'react';
import PropTypes from 'prop-types';

import FlexModal from '../FlexModal';
import CreditBreakdownHeader from '../CreditBreakdownHeader';
import CreditBreakdownRestrictions from '../CreditBreakdownRestrictions';
import CreditBreakdownTable from '../CreditBreakdownTable';
import CreditRedemptionActions from '../CreditRedemptionActions';

export default function CreditBreakdownModal({
  isDisplayed,
  dismissModalHandler,
  details,
  actions,
  appElement,
}) {
  const getBreakdownContent = () => {
    if (details) {
      return (
        <React.Fragment>
          {details.map((section) => {
            switch (section.type) {
              case 'header':
                return (
                  <CreditBreakdownHeader
                    key={`header-${section.title}`}
                    title={section.title}
                    subtitle={section.subtitle}
                  />
                );
              case 'table':
                return (
                  <CreditBreakdownTable
                    key={`table-${section.heading}`}
                    heading={section.heading}
                    items={section.items}
                  />
                );
              case 'list':
                return (
                  <CreditBreakdownRestrictions
                    key={`list-${section.heading}`}
                    heading={section.heading}
                    items={section.items}
                  />
                );
              default:
                return null;
            }
          })}
        </React.Fragment>
      );
    }
    return <div />;
  };

  const footerActions = <CreditRedemptionActions actions={actions} />;

  return (
    <FlexModal
      isOpen={isDisplayed}
      dismissHandler={dismissModalHandler}
      title="Credit details"
      footer={footerActions}
      appElement={appElement}
    >
      {getBreakdownContent()}
    </FlexModal>
  );
}

CreditBreakdownModal.propTypes = {
  isDisplayed: PropTypes.bool.isRequired,
  dismissModalHandler: PropTypes.func.isRequired,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['header', 'table', 'list']).isRequired,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      heading: PropTypes.string,
      items: PropTypes.oneOfType([
        PropTypes.arrayOf(
          PropTypes.shape({
            key: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
          }).isRequired,
        ),
        PropTypes.arrayOf(PropTypes.string),
      ]),
    }).isRequired,
  ).isRequired,
  actions: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  appElement: PropTypes.string.isRequired,
};

CreditBreakdownModal.defaultProps = {
  actions: [],
};
